import React from "react";
import { Link, useLocation } from "react-router-dom";

export const MainNav: React.FC = () => {
  const location = useLocation();

  let activeSection = "";
  if (location.pathname.indexOf("/messages/") > -1) activeSection = "messages";
  else if (location.pathname.indexOf("/playlists/") > -1) activeSection = "playlists";
  else if (location.pathname.indexOf("/screens/") > -1) activeSection = "screens";

  const getLinkClass = (sectionName: string) => {
    if (sectionName === activeSection) return "nav-link active";
    else return "nav-link"
  }

  return (
    <>
      <div id="mainNav" data-testid="main-navigation">
        <div className="nav-container">
          <Link to="/messages/" className={getLinkClass("messages")} id="mainNavMessages" data-testid="nav-messages">
            <span className="nav-icon"><i className="far fa-image"></i></span>
            <span className="nav-text">
              <span className="nav-step">Step 1</span>
              <span className="nav-label">My Content</span>
            </span>
          </Link>
          <Link to="/playlists/" className={getLinkClass("playlists")} id="mainNavPlaylists" data-testid="nav-playlists">
            <span className="nav-icon"><i className="fas fa-list-ul"></i></span>
            <span className="nav-text">
              <span className="nav-step">Step 2</span>
              <span className="nav-label">Playlists</span>
            </span>
          </Link>
          <Link to="/screens/" className={getLinkClass("screens")} id="mainNavScreens" data-testid="nav-screens">
            <span className="nav-icon"><i className="fas fa-tv"></i></span>
            <span className="nav-text">
              <span className="nav-step">Step 3</span>
              <span className="nav-label">Screens</span>
            </span>
          </Link>
        </div>
      </div>
      <div id="mainNavAfter"></div>
    </>
  );
};